(function() { window.GUID_bb316257_d189_4348_82e8_bd218cb7b986 = { getGuid: function() { return "bb316257-d189-4348-82e8-bd218cb7b986"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    class NewsfeedPost {
                        constructor() {
                            this.OnBindEvents();
                        }
                        Dispose() {
                            if (!this.disposed) {
                                this.OnDispose();
                                this.disposed = true;
                            }
                        }
                        OnDispose() {
                            $(document).off('click.newsfeed-post', 'div.newsfeed-post');
                            CS.DOM.$win.off('scroll.markasread');
                        }
                        OnBindEvents() {
                            const me = this;
                            $(document).offon('click.newsfeed-post', 'div.newsfeed-post', (e) => {
                                let $control = $(e.currentTarget);
                                let $target = $(e.target);
                                if ($target.hasClass("publicity") && $target.hasClass("full")) {
                                    window.open($target.attr("data-advertising-url"), "_blank");
                                }
                                if ($target.hasClass("pub-link-btn")) {
                                    window.open($target.attr("href"), "_blank");
                                }
                            });
                            $(document).offon('click.dismiss-post', 'div.dismiss-post', (e) => {
                                let $target = $(e.target);
                                let postId = $target.data("value");
                                let $control = $("div#newsfeed-post-" + postId);
                                me.Dismiss($control);
                                if ($target.hasClass("list-item")) {
                                    let $dropdownButton = $control.find(".dropdown-picker"), $dropdownMenu = $target.closest(".dropdown-post");
                                    $dropdownMenu.css({
                                        "display": "none"
                                    });
                                    $dropdownButton.blur();
                                    $dropdownButton.removeClass("active");
                                }
                            });
                            $('div .newsfeed-post').each((i, v) => {
                                let $body = $(v).find(".post-body");
                                if ($body.length > 0) {
                                    //me.setPhotoSwipeFromDOM(".gallery");
                                    const $message = $body.find(".post-message");
                                    if ($message.length > 0) {
                                        me.setSeeMore($body, $message);
                                    }
                                }
                            });
                            CS.DOM.$win.offon('scroll.markasread', function () {
                                CS.Lag('scroll.lag', 250, function () {
                                    $('.newsfeed-post.new-post').each(function (i) {
                                        let me = this;
                                        let triggerPos = $(this).offset().top + $(this).outerHeight();
                                        var scrollTop = CS.DOM.$win.scrollTop();
                                        var scrollBottom = scrollTop + CS.DOM.$win.height();
                                        if (triggerPos > scrollTop && triggerPos < scrollBottom) {
                                            let postId = $(this).data("postid");
                                            const data = { postId: postId };
                                            CS.Ajax.Post(CS.Url.CSUrl("markpostasread"), data, function (response) {
                                                if (response.success) {
                                                    $(me).animate({ borderColor: "transparent" }, 1000, () => {
                                                        $(me).removeClass('new-post');
                                                    });
                                                }
                                                $(document).trigger("newsfeedpostread");
                                            });
                                        }
                                    });
                                });
                            });
                            if (typeof YT != "undefined") {
                                CS.DOM.$body.off("YouTubeReady.global");
                                me.processNewsfeedYouTubePlayers();
                            }
                            else {
                                CS.DOM.$body.offon("YouTubeReady.global", () => {
                                    me.processNewsfeedYouTubePlayers();
                                });
                            }
                        }
                        Dismiss($control) {
                            let postId = $control.data("postid");
                            const data = { postId: postId }, $parent = $control.parent(), $undoElement = $(`<div class="confirm-action"><div class="col"><p>${CS.Lang("You dismissed this post.", "Vous avez fait disparaître cette publication.", "Has eliminado esta publicación.")}</p></div><div class="col"><button id="undismiss-${postId}" class="undismiss-post">${CS.Lang("Undo", "Annuler", "Anular")}</button></div></div>`);
                            let i = $control.index();
                            $control.find(".dropdown-picker").removeClass("active");
                            $control.find(".dropdown-post").css({
                                "display": "none"
                            });
                            CS.Ajax.Post(CS.Url.CSUrl("dismisspost"), data, function (response) {
                                if (response.success) {
                                    let postHeight = $control.outerHeight();
                                    $control.animate({ "height": 75, opacity: 0 }, 250, () => {
                                        $control.hide();
                                        if (i == 0) {
                                            $parent.prepend($undoElement);
                                        }
                                        else {
                                            $undoElement.insertAfter($parent.children()[i - 1]);
                                        }
                                        $undoElement.animate({ "opacity": 1 }, 250, () => {
                                            let $undismissButton = $undoElement.find(".undismiss-post");
                                            $undismissButton.click(function (e) {
                                                i = $undoElement.index();
                                                CS.Ajax.Post(CS.Url.CSUrl("undismisspost"), data, function (response) {
                                                    if (response.success) {
                                                        $undoElement.fadeOut(250, () => {
                                                            $undoElement.remove();
                                                            $control.show();
                                                            $control.animate({ "height": postHeight, opacity: 1 }, 250, () => {
                                                                $control.css({ "height": "auto" });
                                                            });
                                                        });
                                                    }
                                                });
                                            });
                                        });
                                    });
                                }
                            });
                        }
                        setSeeMore($body, $element) {
                            let height = $body.find(".post-message").innerHeight(), $message = $body.find(".post-message");
                            const maxHeight = 350;
                            let contentIsHidden = false;
                            if (height > maxHeight + 100) {
                                //Ajout d'une section pour l'opacité graduelle dans le bas du post
                                $element.append(`<div class="opacity-gradient"></div>`);
                                let $opacityGradient = $element.find(".opacity-gradient");
                                // Affichage de la section pour le bouton "see more"
                                let $seeMoreDiv = $body.find("div.see-more");
                                $seeMoreDiv.css({
                                    "display": "block"
                                });
                                let $seeMoreButton = $seeMoreDiv.find("button.see-more");
                                //Limitation de la hauteur de la section du message
                                $element.css({
                                    "max-height": maxHeight
                                });
                                contentIsHidden = true;
                                $message.click(function () {
                                    if (contentIsHidden) {
                                        contentIsHidden = false;
                                        $element.css({
                                            "max-height": height * 2
                                        });
                                        $opacityGradient.hide();
                                        $seeMoreButton.off("click");
                                        $seeMoreButton.remove();
                                        return;
                                    }
                                });
                            }
                        }
                        processNewsfeedYouTubePlayers() {
                            let me = this;
                            $.each($(".embed-yt"), (index, v) => {
                                let id = $(v).attr("id");
                                console.log("embed-yt " + id);
                                //if (newsfeedPlayers.find((e) => e.origId == id).length == 0)
                                try {
                                    let player = new YT.Player(id, {
                                        origin: window.location.href,
                                        events: {
                                            'onStateChange': onNewsFeedPlayerStateChange
                                        }
                                    });
                                    player.origId = id;
                                    newsfeedPlayers.push(player);
                                    console.log("adding youtube player " + typeof player.getPlayerState); // + ' ' + JSON.stringify(event));
                                }
                                catch (e) {
                                    console.error(JSON.stringify(e));
                                }
                            });
                        }
                    }
                    WallSections.NewsfeedPost = NewsfeedPost;
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));
var newsfeedPlayers = new Array();
function onNewsFeedPlayerStateChange(event) {
    console.log("onNewsFeedPlayerStateChange " + event.target.id + ' ' + event.data); // + ' ' + JSON.stringify(event));
    if (event.data == YT.PlayerState.PLAYING) {
        for (var i = 0; i < newsfeedPlayers.length; i++) {
            if (newsfeedPlayers[i].id == event.target.id || typeof newsfeedPlayers[i].getPlayerState === "undefined") {
                continue;
            }
            if (newsfeedPlayers[i].getPlayerState() == YT.PlayerState.PLAYING) {
                newsfeedPlayers[i].pauseVideo();
            }
        }
    }
}
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: 'body',
                        childSelector: '.accordion-newsfeed',
                        callback: function (control, e) {
                            new CS.App.Views._Shared.WallSections.NewsfeedPost();
                            new CS.App.Views._Shared.WallSections.NewsfeedPublicity();
                        }
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=newsfeed-post.js.map
